/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import {
  changeInvoicePlan,
  changeInvoiceItemPlan as _changeInvoiceItemPlan,
  getInvoice,
} from '@/services/api/payment/invoice';

// initial state
const state = {
  id: null,
  fees: 0,
  reference: null,
  items: [],
  quantity: 0,
  plan: 'ANNUAL',
  totalTaxesIncl: 0,
  totalTaxesExcl: 0,
  checkout: {
    totalToPay: 0,
  },
};

// getters
const getters = {
  annual: (state) => state.plan === 'ANNUAL',
  fees: (state) => state.items.length * 50,
  quantity: (state) => state.quantity,
  get: (state) => state,
  id: (state) => state.id,
  items: (state) => state.items,
  plan: (state) => state.plan,
  price: (state) => state.checkout.totalToPay || 0,
  priceDetails: (state) => state.priceDetails,
  revenue: (state) => state.totalTaxesIncl,
  tax: (state) => state.totalTaxesIncl - state.totalTaxesExcl,
  totalTaxesIncl: (state) => state.totalTaxesIncl,
};

// actions
const actions = {
  setInvoice({ commit }, invoice) {
    commit('CLEAR');
    commit('SET_INVOICE', invoice);
    return Promise.resolve();
  },
  verifyInvoice({ state }, transaction) {
    if (transaction.status === 'FAILED') {
      return Promise.resolve(`payment/${transaction.id}/regularization`);
    }
    if (state.id) {
      return Promise.resolve(`payment/${state.id}`);
    }
    return Promise.resolve('failure');
  },
  async getInvoiceFromId({ commit, dispatch }, id) {
    try {
      const success = await getInvoice(id);
      dispatch('checkout/setCheckout', success.data.checkout, { root: true });
      commit('SET_INVOICE', success.data);
      return success;
    } catch (err) {
      dispatch('reporting/sendError', { err, currentPage: 'Checkout' }, { root: true });
      return err;
    }
  },
  async changePlan({ commit, state, dispatch }, plan) {
    try {
      const success = await changeInvoicePlan(state.id, plan);
      commit('SET_INVOICE', { ...success.data });
      dispatch('checkout/setCheckout', success.data.checkout, { root: true });
    } catch (err) {
      dispatch('reporting/sendError', { err, currentPage: 'Checkout' }, { root: true });
      throw (err);
    }
  },
  async changeInvoiceItemPlan({ commit, state, dispatch }, plan) {
    try {
      const [item] = state.items;
      const success = await _changeInvoiceItemPlan(item.id, plan);
      commit('SET_INVOICE', { ...success.data });
      dispatch('checkout/setCheckout', success.data.checkout, { root: true });
    } catch (err) {
      dispatch('reporting/sendError', { err, currentPage: 'Checkout' }, { root: true });
      throw (err);
    }
  },
  resetId({ commit }) {
    commit('RESET_ID');
  },
  clear({ commit }) {
    commit('CLEAR');
    return Promise.resolve();
  },
};

// mutations
const mutations = {
  CLEAR(state) {
    state.id = null;
    state.fees = 0;
    state.reference = null;
    state.items = [];
    state.totalTaxesIncl = 0;
    state.totalTaxesExcl = 0;
    state.checkout = {
      totalToPay: 0,
    };
  },
  SET_INVOICE(state, invoice) {
    Object.assign(state, { ...invoice });
  },
  SET_TERMS(state, terms) {
    state.terms = terms;
  },
  RESET_ID(state) {
    Object.assign(state, { id: null });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
